/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_State_ExpiredInputs */

const en_invite_state_expired = /** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite has expired. Ask for a new one.`)
};

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const ar_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const he_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const ur_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const es_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const fr_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const de_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const pt_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const hi_invite_state_expired = en_invite_state_expired;

/** @type {(inputs: Invite_State_ExpiredInputs) => LocalizedString} */
const bn_invite_state_expired = en_invite_state_expired;

/**
* | output |
* | --- |
* | "This invite has expired. Ask for a new one." |
*
* @param {Invite_State_ExpiredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_state_expired = /** @type {((inputs?: Invite_State_ExpiredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_State_ExpiredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_state_expired(inputs)
	if (locale === "he") return he_invite_state_expired(inputs)
	if (locale === "ur") return ur_invite_state_expired(inputs)
	if (locale === "es") return es_invite_state_expired(inputs)
	if (locale === "fr") return fr_invite_state_expired(inputs)
	if (locale === "de") return de_invite_state_expired(inputs)
	if (locale === "pt") return pt_invite_state_expired(inputs)
	if (locale === "hi") return hi_invite_state_expired(inputs)
	if (locale === "bn") return bn_invite_state_expired(inputs)
	return /** @type {LocalizedString} */ ("This invite has expired. Ask for a new one.")
});